var addedTodayItem = false;

$(function() {
  var assetUrl = '//perfumeoil.co.jp/cdn/shop/t/13/assets/index_main_daily_empty.gif?v=74931001884959505051723793127';
  var assetPath = assetUrl.split('index_main_daily_empty.gif');
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var today = d.getDate();
  var fullDateString = year + '.' + month + '.' + today;
  var todayImg = 'index_main_daily_' + today + '.jpg';
  var item = '<div class="item"><a href="/collections/the-original-perfume-oil"><img src="' + assetPath[0] + todayImg + '" alt=""><div class="mainTxt white"><p class="mainTxtTitle">毎日の生活を、より華やかに、より心強く。</p><p class="todaysNo">' + fullDateString + '/Perfume No: ' + today + '</p><p class="mainTxtTxt">The ORIGINAL PERFUME OIL</p></div></a></div>';
  $('.main_visual').prepend(item);
  addedTodayItem = true;
  checkAddedItem = setInterval(function(){
    if(addedTodayItem == true) {
    $('.main_visual').slick(
      {
        infinite: true,
        dots:true,
        slidesToShow: 1,
        centerMode: true, //要素を中央寄せ
        centerPadding:'100px', //両サイドの見えている部分のサイズ
        autoplay:true, //自動再生
        autoplaySpeed: 3000,
        speed:2000,
        responsive: [{
          breakpoint: 480,
            settings: {
              centerMode: true,
              centerPadding:'20px', //両サイドの見えている部分のサイズ
          }
        }]
      }
    );
    clearInterval(checkAddedItem);
    }
  }, 1000 / 24);
});
